import { render, staticRenderFns } from "./EmpresaIndex.vue?vue&type=template&id=0e2dbe60"
import script from "./EmpresaIndex.vue?vue&type=script&lang=js"
export * from "./EmpresaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports